<script setup lang="ts">
import { colors } from '~/utils';

interface Serie {
  name: string;
  data: number[];
}

interface Props {
  title: string;
  height?: number;
  series: Serie[];
  categories: string[];
  valueFormater?: (value: number) => string;
}

const props = defineProps<Props>();

const chartAttrs: any = {
  series: props.series,
  options: {
    chart: {
      animations: {
        enabled: false,
      },
      stacked: true,
      toolbar: {
        show: false,
      },
      type: 'bar',
      zoom: {
        enabled: false,
      },
    },
    colors,
    xaxis: {
      categories: props.categories,
    },
  },
};

if (props.valueFormater) {
  chartAttrs.options.yaxis = {
    labels: {
      formatter: (value: number) => {
        if (typeof props.valueFormater === 'function')
          return props.valueFormater(value);
      },
    },
  };
}
</script>
<template>
  <a-card :title="props.title">
    <a-empty v-if="props.categories.length === 0" />
    <apexchart
      v-else
      type="bar"
      :height="props.height"
      v-bind="chartAttrs"
    ></apexchart>
  </a-card>
</template>
